module.exports = global["jQuery"] = require("-!F:\\qsujuan\\wwwroottwo\\w文康律师\\wenkang\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");